import { render, staticRenderFns } from "./add-users.vue?vue&type=template&id=2645a56d&"
import script from "./add-users.vue?vue&type=script&lang=js&"
export * from "./add-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports